import { useEffect } from 'react'

import { useAppInfo } from 'hooks/useAppInfo'
import { RouterProvider } from 'react-router-dom'
import { router } from 'routes'
import { resolveTrackEnvironment } from 'utils/resolveTrackEnvironment'
import { ThemesEnum } from 'common/enums/themes'
import DarkModeLoader from 'components/DarkModeLoader'
import { WebViewBridgeGuard } from 'components/WebViewBridgeGuard'

import { changeTheme, Theme } from '@interco/inter-ui'
import { TrackData } from '@interco/track'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

const environment = resolveTrackEnvironment()

TrackData.initOrUpdate({
  runtimeEnv: environment,
  projectName: 'mortgage',
  tableName: process.env.NPM_PACKAGE_NAME as string,
  commonData: {
    Environment: environment,
  },
})

function AppContent() {
  const { appInfo } = useAppInfo()
  const appTheme = appInfo?.application

  useEffect(() => {
    changeTheme(appTheme === ThemesEnum.PJ ? Theme.PJ : Theme.PF)
  }, [appTheme])

  return (
    <>
      <DarkModeLoader appInfo={appInfo} />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools />
      </QueryClientProvider>
    </>
  )
}

function App() {
  return (
    <WebViewBridgeGuard>
      <AppContent />
    </WebViewBridgeGuard>
  )
}

export default App
